import { render, staticRenderFns } from "./question-wrap.vue?vue&type=template&id=557e7328&scoped=true&"
import script from "./question-wrap.vue?vue&type=script&lang=js&"
export * from "./question-wrap.vue?vue&type=script&lang=js&"
import style0 from "./question-wrap.vue?vue&type=style&index=0&id=557e7328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e7328",
  null
  
)

export default component.exports